import React from 'react';
import { Icon, Select, Table } from 'semantic-ui-react';
import { Dia, NombrePersonal } from 'src/componentes';
import { LinkCurso } from 'src/componentes/LinkCurso';
import { ResumenesDeCurso } from '../tipos';

type FilaProps = Readonly<{
    cursoInscrito: Readonly<ResumenesDeCurso[number]>;
    cursosDelBloque: Readonly<ResumenesDeCurso>;
    cursoDeDestino?: Readonly<ResumenesDeCurso[number]>;
    alCambiarDestino: (idCurso: number) => void;
}>;

const FilaCambioDeCurso = (props: FilaProps) => {
    const { cursoInscrito, cursosDelBloque, cursoDeDestino, alCambiarDestino } = props;

    return (
        <Table.Row>
            <Table.Cell width='2' selectable>
                <LinkCurso codigo={cursoInscrito.nombre} />
            </Table.Cell>

            <Table.Cell width='1'>
                <Dia dia={cursoInscrito.dia} />
            </Table.Cell>

            <Table.Cell width='2'>
                {cursoInscrito.bloqueHorario.horaInicio} – {cursoInscrito.bloqueHorario.horaTermino}
            </Table.Cell>

            <Table.Cell width='3'>
                {cursoInscrito.profesor && (
                    <NombrePersonal nombre={cursoInscrito.profesor.nombre} patron='%N %P' />
                )}
            </Table.Cell>

            <Table.Cell textAlign='center'>
                <Icon
                    name='long arrow alternate right'
                    size='big'
                    color={cursoDeDestino ? 'green' : 'grey'}
                />
            </Table.Cell>

            <Table.Cell width='2'>
                <Select
                    fluid
                    clearable
                    search
                    selectOnBlur={false}
                    noResultsMessage='No hay resultados'
                    value={cursoDeDestino ? cursoDeDestino.id : ''}
                    onChange={(_, { value }) => {
                        if (cursoInscrito.id !== value) {
                            alCambiarDestino(value as number);
                        }
                    }}
                    options={cursosDelBloque.map(c => ({
                        key: c.id,
                        value: c.id,
                        text: c.nombre,
                    }))}
                />
            </Table.Cell>

            <Table.Cell width='1'>{cursoDeDestino && <Dia dia={cursoDeDestino.dia} />}</Table.Cell>

            <Table.Cell width='2'>
                {cursoDeDestino && (
                    <>
                        {cursoDeDestino.bloqueHorario.horaInicio} –{' '}
                        {cursoDeDestino.bloqueHorario.horaTermino}
                    </>
                )}
            </Table.Cell>

            <Table.Cell width='3'>
                {cursoDeDestino && cursoDeDestino.profesor && (
                    <NombrePersonal nombre={cursoDeDestino.profesor.nombre} patron='%N %P' />
                )}
            </Table.Cell>
        </Table.Row>
    );
};

export default FilaCambioDeCurso;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/CambiosDeCurso/componentes/FilaCambioDeCurso.tsx